import { useRefreshCandidate } from "#candidate/redux/actions"
import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateIdPut } from "#candidate/services/api"
import InputDateTime from "#common/input/InputDateTime"
import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { Box, Button, Typography } from "@mui/material"
import { Fragment, useCallback, useState } from "react"

export default function CandidateStatusDate({ title, status, label, message }) {
	const [open, setOpen] = useState(false)
	const [date, setDate] = useState(null)
	const [disabled, setDisabled] = useState(false)

	const { candidateId } = useCandidateRedux()
	const { refresh } = useRefreshCandidate()

	const success = () => {
		setOpen(false)
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(candidateIdPut, { success, end })

	const handleSubmit = useCallback(() => {
		setDisabled(true)
		fetch(candidateId, {
			status,
			date,
		})
	}, [candidateId, date, fetch, status])

	return (
		<Fragment>
			<Button onClick={() => setOpen(!open)}>{title}</Button>
			<DialogMaster
				{...{
					open,
					setOpen,
					maxWidth: "sm",
					title,
					handleSubmit,
					disabled,
				}}
			>
				<Box display="flex" flexDirection="column" gap={2} alignItems={"center"}>
					<Typography variant="h6">{message}</Typography>
					<InputDateTime value={date} onChange={setDate} disablePast />
				</Box>
			</DialogMaster>
		</Fragment>
	)
}
